import {
  Box,
  Button,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import dayjs from 'dayjs';
import React from 'react';

export default function categorydetailmodal({ details, handleclose }) {
  const data = details?.data?.count;
  // const data = details;
  console.log('data of category', data);
  return (
    // <Box
    //   p={1}
    //   mt={2}
    //   style={{
    //     // width: '100%',
    //     // alignItems: 'center',
    //     // display: 'flex',
    //     flexDirection: 'column'
    //   }}
    // >

    <Box p={1} mt={2} style={{ width: '100%' }}>
      <Typography variant="h5" textAlign={'center'}>
        Category Statistics
      </Typography>

      <Card style={{ marginTop: 20 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography variant="body2" fontWeight={'bold'}>
                  No of Products
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2" fontWeight={'bold'}>
                  No of Orders
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2" fontWeight={'bold'}>
                  No of Sales
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2 " fontWeight={'bold'}>
                  Avg Rating
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {/* {details?.map((item) => (
              <>
                {console.log('item of historyLogs', item)} */}
            <TableRow>
              <TableCell>
                <Typography variant="body2" color="black">
                  {data?.count_products}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2">{data?.count_orders}</Typography>
              </TableCell>
              <TableCell>
                <Typography variant="caption">{data?.total_sales}</Typography>
              </TableCell>
              <TableCell>
                <Typography variant="caption">{data?.average ? data?.average : 0}</Typography>
              </TableCell>
            </TableRow>
            {/* </>
            ))} */}
          </TableBody>
        </Table>
      </Card>

      <Box
        style={{
          justifyContent: 'flex-end',
          display: 'flex',
          marginTop: 50,
          alignItems: 'flex-end'
        }}
      >
        <Button color="primary" variant="contained" onClick={handleclose} size={'small'}>
          Close
        </Button>
      </Box>
    </Box>
  );
}
